// ============================================
// Northworld Messenger — Entry Point
// ============================================
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { initSentry } from '@/shared/lib/sentry'
import './styles/globals.css'

// Service Worker registration is handled by vite-plugin-pwa (injectManifest).
// Do NOT register manually here — it causes double registration and update conflicts.

// Initialize Sentry error monitoring
initSentry()

const root = document.getElementById('root')!
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
